import API from 'app/api';
import logError from 'app/error/logError';

const createToken = ({ isUserAuthenticated, anonymousId }) => {
  const {
    cxApiParams: { accountAuthClientId, anonClientId },
  } = window.etp.config;
  const headers = {
    Authorization: `Basic ${window.btoa(
      `${isUserAuthenticated ? accountAuthClientId : anonClientId}:`,
    )}`,
    'ETP-Anonymous-Id': anonymousId,
  };
  const grantType = isUserAuthenticated
    ? 'grant_type=etp_rt_cookie'
    : 'grant_type=client_id';

  return API.Auth.createToken(grantType, { headers }).catch(logError);
};

export { createToken };
